export default "__VITE_ASSET__DIKnoUIj__ 1458w";